module.exports = __webpack_public_path__ + "static/media/chat03-1.8300a316.svg";